import { useParams } from 'react-router-dom';
import { useLeadCollection } from '@/hooks/useLeadCollection.ts';
import { type Lead, LeadId } from '@/models/entities/lead.ts';
export function useSelectedLead(): Lead | null {
  const leadCollection = useLeadCollection();
  const { leadId } = useParams<{ leadId: string }>();
  return leadId ? leadCollection.getLead(LeadId.parse(leadId)) : null;
}
